export default [
  {
    path: '/admin/customer-profiles',
    name: 'customer-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer/profile')
  }
]